/**
 * The theme the game's panels wear (a `data-theme` of tokens.css): one place to switch it.
 * "Parchment" (the user's choice of 2026-10-09, adopted after the trial on the inventory, the
 * character and the storage): every game panel and the menu wear it.
 */
export const PANEL_THEME = 'parchment';
